import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class ScormQuestionAnswerCommand extends AnswerCommand {
  constructor(scormQuestion) {
    super(tactileoAnswersDTOTypes.POLL_QUESTION, scormQuestion);
    this.answer = scormQuestion.answer;
  }
}
